import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const UnitMeasureIndex = () => {
    const navigate = useNavigate();

    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "description",
            label: "Description",
            placeholder: "Search by description..."
        },
        {
            type: "text",
            name: "type",
            label: "Type",
            placeholder: "Search by type..."
        }
    ], []);

    const columns = useMemo(() => [
        { 
            title: 'Answer Type KPI Description', 
            dataIndex: 'description', 
            key: 'description', 
            sortable: true 
        },
        { 
            title: 'Type', 
            dataIndex: 'type', 
            key: 'type', 
            sortable: true 
        },
        { 
            title: 'Input Type', 
            dataIndex: 'inputType', 
            key: 'inputType', 
            sortable: true 
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 100,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/answerTypeKPI/edit/${record.unitMeasureID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Answer Type KPI"
            apiEndpoint="/UnitMeasure/getAllPaginated"
            toggleActiveEndpoint="/UnitMeasure/toggleActive"
            toggleDeletedEndpoint="/UnitMeasure/toggleDeleted"
            newRoute="/answerTypeKPI/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="unitMeasureID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default UnitMeasureIndex;
